import { render, staticRenderFns } from "./DamagesView.vue?vue&type=template&id=250c452d&"
import script from "./DamagesView.vue?vue&type=script&lang=js&"
export * from "./DamagesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports